import React from 'react'
import { useTranslation } from 'react-i18next'

import { PAYTRIE_LOGIN_URL } from '@/constants/paytrieAppUrls'
import { CorporateSupportLine } from './CorporateSupportLine'

type RegistrationVerifiedPageProps = {
  businessEmail: string
}

const RegistrationVerifiedPageComponent = ({
  businessEmail,
}: RegistrationVerifiedPageProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-6" data-testid="text-verified-container">
      <h1 className="text-2xl font-normal" data-testid="text-verified-heading">
        {t('registrationVerifiedPage.title')}
      </h1>

      <p className="text-base" data-testid="text-verified-message">
        {t('registrationVerifiedPage.message')}
      </p>

      <p className="text-base font-semibold" data-testid="text-verified-email">
        {businessEmail}
      </p>

      <a
        href={PAYTRIE_LOGIN_URL}
        className="inline-flex items-center justify-center py-4 px-4 w-full uppercase text-sm tracking-wide bg-black text-snow dark:bg-semiWhite dark:text-black"
        data-testid="link-verified-go-to-paytrie"
      >
        {t('registrationVerifiedPage.loginButton')}
      </a>

      <CorporateSupportLine />
    </div>
  )
}

export const RegistrationVerifiedPage = React.memo(
  RegistrationVerifiedPageComponent
)
